// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeExperience {
  padding: 2em 0;
}

.homeExperience h2 {
  font-size: 1.5rem;
  color: var(--clr-gray800);
  white-space: nowrap;
  text-align: center;
}

.homeExperience__container {
  display: grid;
  gap: 3rem;
  margin-top: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
}

.homeExperience__card {
  width: 100%;
  display: flex;
  flex-direction: column;
  /* justify-self: center; */
  justify-content: space-between;
  gap: 2rem;
  background: var(--clr-secondary);
  /* background: var(--clr-light); */
  padding: 2em;
  border-radius: 1em;
  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.1);
}

.homeExperience__quoteIcon {
  width: 3rem;
  display: flex;
  fill: var(--clr-primary);
}

.homeExperience__img {
  display: block;
  object-fit: cover;
  width: 10rem;
  height: 10rem;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
}

.homeExperience__cardText {
  display: flex;
  flex-direction: column-reverse;
  /* gap: 1.5rem; */
  justify-content: space-between;
  font-family: "Avenir Next";
}

.homeExperience__cardText p {
  color: var(--clr-gray600);
  line-height: 1.8;
  font-size: 1.1rem;
  font-weight: 100;
}

.homeExperience__userInfo h3 {
  font-weight: 500;
}

.homeExperience__userInfo span {
  color: var(--clr-primary);
  font-weight: 600;
  font-size: 0.8rem;
}

@media (min-width: 375px) {
  .homeExperience h2 {
    font-size: 1.8rem;
  }
}

@media (min-width: 425px) {
  .homeExperience__cardText {
    flex-direction: row;
    align-items: center;
    /* gap: 1.5rem; */
    justify-content: space-between;
    font-family: "Avenir Next";
  }

  .homeExperience__cardText p {
    /* max-width: 12.5rem; */
    max-width: 17rem;
  }
}

@media (min-width: 600px) {
  .homeExperience__container {
    grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  }
}

@media (min-width: 768px) {
  .homeExperience {
    margin-top: 5rem;
  }
  .homeExperience h2 {
    font-size: 2rem;
  }
}
/* 
@media (min-width: 992px) {
  .homeExperience__card:last-of-type {
    grid-column: span 2;
    max-width: 35rem;
    margin: 0 auto;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/components/HomeComponents/HomeExperience/HomeExperience.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;;;;;;;GAOG","sourcesContent":[".homeExperience {\n  padding: 2em 0;\n}\n\n.homeExperience h2 {\n  font-size: 1.5rem;\n  color: var(--clr-gray800);\n  white-space: nowrap;\n  text-align: center;\n}\n\n.homeExperience__container {\n  display: grid;\n  gap: 3rem;\n  margin-top: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n}\n\n.homeExperience__card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  /* justify-self: center; */\n  justify-content: space-between;\n  gap: 2rem;\n  background: var(--clr-secondary);\n  /* background: var(--clr-light); */\n  padding: 2em;\n  border-radius: 1em;\n  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.1);\n}\n\n.homeExperience__quoteIcon {\n  width: 3rem;\n  display: flex;\n  fill: var(--clr-primary);\n}\n\n.homeExperience__img {\n  display: block;\n  object-fit: cover;\n  width: 10rem;\n  height: 10rem;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n}\n\n.homeExperience__cardText {\n  display: flex;\n  flex-direction: column-reverse;\n  /* gap: 1.5rem; */\n  justify-content: space-between;\n  font-family: \"Avenir Next\";\n}\n\n.homeExperience__cardText p {\n  color: var(--clr-gray600);\n  line-height: 1.8;\n  font-size: 1.1rem;\n  font-weight: 100;\n}\n\n.homeExperience__userInfo h3 {\n  font-weight: 500;\n}\n\n.homeExperience__userInfo span {\n  color: var(--clr-primary);\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n@media (min-width: 375px) {\n  .homeExperience h2 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (min-width: 425px) {\n  .homeExperience__cardText {\n    flex-direction: row;\n    align-items: center;\n    /* gap: 1.5rem; */\n    justify-content: space-between;\n    font-family: \"Avenir Next\";\n  }\n\n  .homeExperience__cardText p {\n    /* max-width: 12.5rem; */\n    max-width: 17rem;\n  }\n}\n\n@media (min-width: 600px) {\n  .homeExperience__container {\n    grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .homeExperience {\n    margin-top: 5rem;\n  }\n  .homeExperience h2 {\n    font-size: 2rem;\n  }\n}\n/* \n@media (min-width: 992px) {\n  .homeExperience__card:last-of-type {\n    grid-column: span 2;\n    max-width: 35rem;\n    margin: 0 auto;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
